import { GetControleMateriaisByIdResponse } from "../../../data/daos/read/get_controle_materiais_by_id";
import { IGetControleMateriaisByIdUseCase } from "../../../presentation/useCases/read/get_controle_materiais_by_id_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetControleMateriaisByIdUseCase
 */

export class GetControleMateriaisByIdUseCase implements IGetControleMateriaisByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getControleMateriaisById(id: number): Promise<GetControleMateriaisByIdResponse> {
    const response = await this.repository.getByIdControleMateriais({ id });
    return response;
  }
}
